
export const GlobalVariable = Object.freeze({
//    BASE_API_URL: 'http://localhost:3010/',
    // BASE_API_URL: 'http://87.117.234.75:4010/',
    BASE_API_URL: 'https://api.sadhanachart.com/',
    Superadmin : 1,
    Admin : 2,
    Mentor  : 4,
    Mentee : 0,
    GREEN: 3,
    RED:1,
    ORANGE:2
    // activity >=3 : green
    // activity = 2: orange
    // activity<= 1 : red
});





// WEBPACK FOOTER //
// ./src/global.ts